export const iconFontAwesomeAlphabetQ = (
	<i className="fa-solid fa-q"></i>
);
